var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.246 4.768a1.9 1.9 0 1 1 1.438-2.523h20.275a1.9 1.9 0 1 1 1.482 2.53l-3.908 9.871a1.9 1.9 0 0 1-1.49 2.99l-4.15 10.2a1.9 1.9 0 1 1-2.65-.18L10.367 17.61a1.9 1.9 0 0 1-1.635-3.236L4.246 4.768zM16.479 27.2l-4.971-10.237a1.892 1.892 0 0 0 .36-1.792l4.1-2.905 4.192 2.916a1.898 1.898 0 0 0 .635 2.046l-4.066 9.992a1.917 1.917 0 0 0-.251-.017zm-1.654-15.73L11.07 14.13a1.89 1.89 0 0 0-1.14-.287L5.931 5.282l8.894 6.187zm11.14-7.898-.007-.017H5.742l10.22 7.109 10.002-7.092zm-3.542 10.32a1.903 1.903 0 0 0-1.469.245l-3.85-2.678 8.733-6.192-3.414 8.623z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/BAR.328f0588674a24898b29ada7b37cc4ba.svg";
export { ForwardRef as ReactComponent };